import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import WrapperComponent from './commonComponents/WrapperComponent';

const BlankComponent = () => {
    const [mediaType, setMediaType] = useState('Image'); // Default selected media type
    const [cards, setCards] = useState([]); // State to store cards
    const [jsonObject, setJsonObject] = useState([]); // State to store JSON object

    const handleAddCard = () => {
        if (cards.length >= 10) {
            alert('You can only add up to 10 cards.');
            return;
        }
        setCards([...cards, { id: Date.now(), messageBody: '', buttonText: '', url: '', quickReplyText: '' }]);
    };

    const handleInputChange = (id, field, value) => {
        const updatedCards = cards.map((card) =>
            card.id === id ? { ...card, [field]: value } : card
        );
        setCards(updatedCards);

        // Generate JSON object
        const updatedJson = updatedCards.map((card) => ({
            messageBody: card.messageBody,
            buttonText: card.buttonText,
            url: card.url,
            quickReplyText: card.quickReplyText,
        }));
        setJsonObject(updatedJson);
    };

    const handleRemoveCard = (id) => {
        const updatedCards = cards.filter((card) => card.id !== id);
        setCards(updatedCards);

        // Update JSON object
        const updatedJson = updatedCards.map((card) => ({
            messageBody: card.messageBody,
            buttonText: card.buttonText,
            url: card.url,
            quickReplyText: card.quickReplyText,
        }));
        setJsonObject(updatedJson);
    };

    const handleMediaTypeChange = (e) => {
        setMediaType(e.target.value);
    };

    return (
        <WrapperComponent>
            <div className="container mt-4">
                <h2 className="mb-4">Blank Component</h2>
                <p>This is a blank component. Add your content here.</p>

                {/* First Row: Add Carousel Cards Button */}
                <div className="row mb-3">
                    <div className="col text-end">
                        <button className="btn btn-primary" onClick={handleAddCard}>Add Carousel Cards</button>
                    </div>
                </div>

                {/* Second Row: Media Type Selection */}
                <div className="row mb-3 align-items-center">
                    <div className="col-md-2">
                        <label className="form-label fw-bold">Media Type</label>
                    </div>
                    <div className="col-md-10">
                        <div className="form-check form-check-inline">
                            <input
                                className="form-check-input"
                                type="radio"
                                name="mediaType"
                                id="mediaTypeImage"
                                value="Image"
                                checked={mediaType === 'Image'}
                                onChange={handleMediaTypeChange}
                            />
                            <label className="form-check-label" htmlFor="mediaTypeImage">
                                Image
                            </label>
                        </div>
                        <div className="form-check form-check-inline">
                            <input
                                className="form-check-input"
                                type="radio"
                                name="mediaType"
                                id="mediaTypeVideo"
                                value="Video"
                                onChange={handleMediaTypeChange}
                            />
                            <label className="form-check-label" htmlFor="mediaTypeVideo">
                                Video
                            </label>
                        </div>
                    </div>
                </div>

                {/* Third Row: Media Upload */}
                <div className="row mb-3 align-items-center">
                    <div className="col-md-2">
                        <label className="form-label fw-bold">Media</label>
                    </div>
                    <div className="col-md-10">
                        <input
                            type="file"
                            className="form-control"
                            accept={mediaType === 'Image' ? 'image/*' : 'video/*'}
                        />
                    </div>
                </div>
                {/* Dynamically Added Cards */}
                <div
                    className="d-flex flex-row overflow-auto"
                    style={{
                        whiteSpace: 'nowrap', // Prevent cards from wrapping to the next line
                        overflowX: 'auto', // Enable horizontal scrolling
                        paddingBottom: '10px', // Add some spacing below the cards
                    }}
                >
                    {cards.map((card, index) => (
                        <div
                            key={card.id}
                            className="card me-3"
                            style={{
                                minWidth: '300px', // Set a fixed width for each card
                                flex: '0 0 auto', // Prevent cards from shrinking or growing
                            }}
                        >
                            <div className="card-header d-flex justify-content-between align-items-center">
                                <span>Card {index + 1}</span>
                                <button
                                    className="btn btn-danger btn-sm"
                                    onClick={() => handleRemoveCard(card.id)}
                                >
                                    Remove
                                </button>
                            </div>
                            <div className="card-body">
                                {/* Textarea with Formatting Options */}
                                <div className="mb-3">
                                    <textarea
                                        className="form-control mb-2"
                                        rows="3"
                                        placeholder="Enter your text here..."
                                            value={card.messageBody}
                                        onChange={(e) =>
                                            handleInputChange(card.id, 'messageBody', e.target.value)
                                        }
                                        id={`textarea-${card.id}`}
                                    ></textarea>
                                    <div className="d-flex">
                                        {/* Insert Smiley */}
                                        <button
                                            className="btn btn-secondary btn-sm me-2"
                                            onClick={() => {
                                                const textarea = document.getElementById(`textarea-${card.id}`);
                                                const cursorPosition = textarea.selectionStart;
                                                const updatedText =
                                                    card.messageBody.slice(0, cursorPosition) +
                                                    '😊' +
                                                    card.messageBody.slice(cursorPosition);
                                                handleInputChange(card.id, 'messageBody', updatedText);
                                            }}
                                        >
                                            😊
                                        </button>

                                        {/* Bold */}
                                        <button
                                            className="btn btn-secondary btn-sm me-2"
                                            onClick={() => {
                                                const textarea = document.getElementById(`textarea-${card.id}`);
                                                const selectedText = textarea.value.substring(
                                                    textarea.selectionStart,
                                                    textarea.selectionEnd
                                                );
                                                if (selectedText) {
                                                    const updatedText = textarea.value.replace(
                                                        selectedText,
                                                        `**${selectedText}**`
                                                    );
                                                    handleInputChange(card.id, 'messageBody', updatedText);
                                                }
                                            }}
                                        >
                                            <i className="fas fa-bold"></i>
                                        </button>

                                        {/* Italic */}
                                        <button
                                            className="btn btn-secondary btn-sm me-2"
                                            onClick={() => {
                                                const textarea = document.getElementById(`textarea-${card.id}`);
                                                const selectedText = textarea.value.substring(
                                                    textarea.selectionStart,
                                                    textarea.selectionEnd
                                                );
                                                if (selectedText) {
                                                    const updatedText = textarea.value.replace(
                                                        selectedText,
                                                        `*${selectedText}*`
                                                    );
                                                    handleInputChange(card.id, 'messageBody', updatedText);
                                                }
                                            }}
                                        >
                                            <i className="fas fa-italic"></i>
                                        </button>

                                        {/* Underline */}
                                        <button
                                            className="btn btn-secondary btn-sm"
                                            onClick={() => {
                                                const textarea = document.getElementById(`textarea-${card.id}`);
                                                const selectedText = textarea.value.substring(
                                                    textarea.selectionStart,
                                                    textarea.selectionEnd
                                                );
                                                if (selectedText) {
                                                    const updatedText = textarea.value.replace(
                                                        selectedText,
                                                        `<u>${selectedText}</u>`
                                                    );
                                                    handleInputChange(card.id, 'messageBody', updatedText);
                                                }
                                            }}
                                        >
                                            <i className="fas fa-underline"></i>
                                        </button>
                                    </div>
                                </div>

                                {/* Input Fields */}
                                <div className="row mb-3">
                                    <div className="col-md-6">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter Button Text"
                                            value={card.buttonText}
                                            onChange={(e) =>
                                                handleInputChange(card.id, 'buttonText', e.target.value)
                                            }
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="https://www.domain.com"
                                            value={card.url}
                                            onChange={(e) =>
                                                handleInputChange(card.id, 'url', e.target.value)
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter quick reply button text"
                                            value={card.quickReplyText}
                                            onChange={(e) =>
                                                handleInputChange(card.id, 'quickReplyText', e.target.value)
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* JSON Object Preview */}
                {jsonObject.length > 0 && (
                    <div className="mt-4">
                        <h4>Generated JSON Object:</h4>
                        <pre>{JSON.stringify(jsonObject, null, 2)}</pre>
                    </div>
                )}
            </div>
        </WrapperComponent>
    );
};

export default BlankComponent;